// Module
var code = "<h2 id=\"direct-debit-is-a-convenient-way-to-pay-your-student-loan-bill\">Direct Debit is a convenient way to pay your student loan bill.</h2> <p>Apply for Direct Debit. Once approved, you may even qualify for an interest rate reduction.</p> ";
// Exports
export default code;